module.exports = __webpack_public_path__ + "img/twitch-brands.eef3117d.svg";